// extracted by mini-css-extract-plugin
export default {"title":"Filter_title__FiCtw","icon":"Filter_icon__yR4vV"};